"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsSectionFooter = void 0;
/**
 * @copyright
 * Copyright (c) 2024 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */
var React = __importStar(require("react"));
var OnlineOfflineMode_1 = require("icf-search-client-shared/lib/constants/OnlineOfflineMode");
var SearchResultsPagerContainer_1 = require("./SearchResultsPagerContainer");
var ShowOfflineButtonContainer_1 = require("./ShowOfflineButtonContainer");
var SearchResultsSectionFooter = function (_a) {
    var emitTrackingEvent = _a.emitTrackingEvent, hideOfflineButton = _a.hideOfflineButton, navigation = _a.navigation, onlineOfflineMode = _a.onlineOfflineMode, onOfflineButtonClicked = _a.onOfflineButtonClicked, pageNumber = _a.pageNumber, queryOptions = _a.queryOptions, resultsContext = _a.resultsContext, resultsPerPage = _a.resultsPerPage;
    var onLastPage = pageNumber >= Math.ceil(resultsContext.totalItemCount / resultsPerPage);
    return (React.createElement(React.Fragment, null,
        onlineOfflineMode === OnlineOfflineMode_1.ONLINE_OFFLINE_MODE_ONLINE && !hideOfflineButton && onLastPage && (React.createElement(ShowOfflineButtonContainer_1.ShowOfflineButtonContainer, { onClick: onOfflineButtonClicked })),
        React.createElement(SearchResultsPagerContainer_1.SearchResultsPagerContainer, { dataQueryOptions: queryOptions, emitTrackingEvent: emitTrackingEvent, getPageLinkTo: navigation.getPageLinkTo, resultsContext: resultsContext, pageNumber: pageNumber, resultsPerPage: resultsPerPage })));
};
exports.SearchResultsSectionFooter = SearchResultsSectionFooter;
exports.SearchResultsSectionFooter.displayName = "SearchResultsSectionFooter";
//# sourceMappingURL=SearchResultsSectionFooter.js.map